

export const AUTH_START= 'auth/AUTH_STAR';
export const AUTH_SUCCESS= 'auth/AUTH_SUCCESS';
export const AUTH_USER= 'auth/AUTH_USER';
export const AUTH_USER_REMOVE= 'auth/AUTH_USER_REMOVE';
export const AUTH_FAIL= 'auth/AUTH_FAIL';
export const AUTH_LOGOUT= 'auth/AUTH_LOGOUT';
export const SET_AUTH_REDIRECT_PATH= 'auth/SET_AUTH_REDIRECT_PATH';
